/**
 * Application DEFAULT SETTINGS
 */
export const fsDefaultSettings = {
    dateEnum: 'FRANCE_SPAIN_UNITED_KINGDOM',
    dateFormat: 'DD/MM/YYYY HH:mm:ss',
};

export const ADMIN_CLIENT_ID = 'FIDES';
export const ADMIN_PRIVILEGE_ID = 11;
export const CASHPOOL_MODULE_ID = 'CASHPOOL';
export const VIEW_LEVEL = "1";
export const PORTAL_DIRECTORY = '/app';
export const CPS = 'CPS';

export const CREDIT_SUISSE_ROUTES = {
    forgotPassword: '/forgot-password/cs',
    login: '/login/cs',
    dashboard: '/dashboard/cs',
    logout: '/logout/cs',
    changePassword: '/change-password/cs',
    settings: '/settings/cs',
    common: '/cs'
};

export const BRAND_IMAGE_PATH = {
    fides: '../../../assets/images/fides-logo.svg',
    creditSuisse: '../../../assets/images/ico-app_online_banking.png'
};

export const CREDIT_SUISSE_STATES = {
    login: 'public.cs',
    forgotPassword: 'public.csforgot-password',
    dashboard: 'app.csdashboard',
    logout: 'public.cslogout',
    changePassword: 'app.userprofile.cs-change-password',
    settings: 'app.userprofile.cs-settings'
};
